import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

const TableOfContent = ({ refs }) => {
  const tableOfContent = [
    { title: 'Introduction', ref: refs.heroRef },
    { title: 'Acceptance of Terms', ref: refs.acceptanceRef },
    { title: 'Our Services', ref: refs.servicesRef },
    { title: 'User Obligations', ref: refs.userObligationsRef },
    { title: 'Intellectual Property', ref: refs.intellectualPropertyRef },
    { title: 'Limitation of Liability', ref: refs.limitationRef },
    { title: 'Governing Law & Dispute Resolution', ref: refs.governingLawRef },
    { title: 'Changes to These Terms', ref: refs.changesRef },
  ];

  return (
    <Box sx={{ my: 4 }}>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 200,
          textAlign: 'left',
          my: 2,
          textTransform: 'capitalize',
        }}
      >
        Table of Contents
      </Typography>
      {tableOfContent.map((item, i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            alignItems: 'center',
          }}
        >
          <Typography sx={{ marginY: 1, ml: 2 }}>{i + 1}.</Typography>
          <Typography
            component="a"
            onClick={() =>
              item.ref.current.scrollIntoView({ behavior: 'smooth' })
            }
            sx={{
              textTransform: 'capitalize',
              display: 'flex',
              flexDirection: 'column',
              color: 'purple',
              cursor: 'pointer',
              marginY: 1,
              ml: 2,
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {item.title}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

TableOfContent.propTypes = {
  refs: PropTypes.object,
};

export default TableOfContent;
